import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "single-device",
  "use": "single-device-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"single-device\"><path d=\"M14.167 10.667V2.8a.8.8 0 00-.8-.8H2.633a.8.8 0 00-.8.8v7.867h12.334zm-11-7.334h9.666v6H3.167v-6zm12.833 8v.534a.8.8 0 01-.8.8H.8a.8.8 0 01-.8-.8v-.534h6.667c0 .184.149.334.333.334h2c.184 0 .333-.15.333-.334H16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol